module.exports = __webpack_public_path__ + "static/media/screenshot-3.c694789e.png";